import React from "react";
import { Props } from "./types";
import { Assignable, Removable, Tag as T } from "@planzone/dto";
import { useAssignTag } from "@planzone/view-models";
import { Tag } from "@common/tag";
import styles from "./styles.scss";
import { TagIcon } from "./tagIcon";
import { TagForm } from "@root/client/common/tagForm";
import { VisibilityWatcher } from "@common/visibilityWatcher";

function TagList({ tags, project }: Props) {
  const { isRequestPending, assignTag } = useAssignTag();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.tagList}>
          <div className={styles.tags}>
            {tags.map((tag) => (
              <Tag
                project={project}
                tag={tag}
                removable={Removable.PROJECT}
                removableId={project.uuid}
              />
            ))}
            {!isRequestPending && show && (
              <div onClick={isVisible ? hide : show}>
                <TagIcon className={styles.icon} />
              </div>
            )}
          </div>
          <div></div>
          {isVisible && (
            <div className={styles.form}>
              <TagForm
                filters={tags}
                type="projects"
                submit={(tag: T) => {
                  assignTag({
                    project: project,
                    assignable: Assignable.PROJECT,
                    assignableId: project.uuid,
                    tag,
                  });
                  hide();
                }}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { TagList };
